import { Component, TemplateRef, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { SecurityService } from "src/app/security/services/security.service";
import { AccountService } from "src/app/services";

@Component({
  selector: "app-logout-modal",
  templateUrl: "./logout-modal.component.html"
})
export class LogoutModalComponent {
  @ViewChild('logoutModal', { static: false }) modal?: TemplateRef<any>;

  modalRef: BsModalRef;

  constructor(
    private modalService: BsModalService,
    private securityService: SecurityService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {}
  
    ngOnInit() {}
   
    openModal() {
      this.modalRef = this.modalService.show(this.modal as TemplateRef<any>, {
        class: 'modal-lg modal-dialog-centered',
        backdrop: true,
        ignoreBackdropClick: true,
        keyboard: false,
      });
    }

    closeModal(): void {
      this.modalRef.hide();
    }

    signOut() {
      this.closeModal();
      this.securityService.signOut();
    }

    redirectSelectSubjectObliged(){
      this.closeModal();
      this.router.navigate(['/select'], { relativeTo: this.activatedRoute });
    }

}